/**
 * This script manages which payment methods (Card, Apple Pay, Google Pay, PayPal) are available to use on the Donate Form and Ticketing Form
 * 
 * At the point of init, the payment methods might not have finished loading, so instead of passing in an opts object, use the setters to set the payment methods once loaded:
 * cardElements - used for card payments
 * expressElements - used for Apple Pay, Google Pay and PayPal
 */

// Payment method types
const PAYMENT_METHOD_CARD = 'card';
const PAYMENT_METHOD_EXPRESS_CHECKOUT = 'express_checkout';

export default class PaymentMethodUtils {
	constructor() {
		this.ui = {
			cardBtn: $('.js-card-btn'),
			expressCheckoutContainer: $('.js-express-checkout'),

			billingNameLabel: $('.js-billing-name'),

			cardPaymentText: $('.js-card-payment-text'),

			cardElementsContainer: $('.js-card-elements'),

			paymentMethodIdField: $('#sessionId'), // PaymentMethod ID gets saved as session_id on the DB
			paymentIntentIdField: $('#trackingId'), // PaymentIntent ID gets saved as trackingid on the DB
			paymentMethodField: $('#paymentMethod'),
		};

		this.cardElements = null;
		this.expressElements = null;

		this.repeatDonationPaymentMethods = {
			'card': this.ui.cardBtn
		};

		this.singleDonationPaymentMethods = {
			'card': this.ui.cardBtn,
			'express-checkout': this.ui.expressCheckoutContainer
		};
	}

	bindEvents() {
		this.ui.cardBtn.on('click', this.onClickCardBtn.bind(this));
	}

	setCardElements(cardElements) {
		this.cardElements = cardElements;
	}

	setExpressElements(expressElements) {
		this.expressElements = expressElements;
	}

	// Returns a map of payment method name => container of available payment methods
	getAvailable() {
		const singleDonationPaymentMethods = { ...this.singleDonationPaymentMethods };

		// Only show Express Checkout element if it loaded
		if(!this.expressElements?.mounted) {
			console.log('Stripe Express Checkout element not mounted, express-checkout no longer a payment method.');
			delete singleDonationPaymentMethods['express-checkout'];
		}

		console.log("PaymentMethodUtils.getAvailable", Object.keys(singleDonationPaymentMethods));

		return singleDonationPaymentMethods;
	}

	hideAll() {
		const allPaymentMethods = {
			...this.repeatDonationPaymentMethods,
			...this.singleDonationPaymentMethods
		};

		console.log('PaymentMethodUtils.hideAll', allPaymentMethods);

		Object.values(allPaymentMethods).forEach(container => {
			container?.hide();
		});
	}

	show(paymentMethodToContainerMap) {
		console.log('PaymentMethodUtils.show', paymentMethodToContainerMap);

		Object.values(paymentMethodToContainerMap).forEach(container => {
			container?.show();
		});
	}

	// This method updates the payment method screen to show the payment methods that are available.
	showAvailable() {
		console.log('PaymentMethodUtils.showAvailable');

		// First, hide everything, it makes it simpler when swapping between repeat/single and
		// when changing the donation amount as we don't need to know what's visible, we can
		// just show what needs to be shown.
		this.hideAll();

		const availablePaymentMethods = this.getAvailable();
		this.show(availablePaymentMethods);
	}

	// Simple helper to determine what payment method the user used based on the things they interacted with
	getUsedPaymentMethod() {
		console.log("PaymentMethodUtils.getUsedPaymentMethod");

		if(this.expressElements?.isSelectedMethod) {
			return PAYMENT_METHOD_EXPRESS_CHECKOUT;
		}

		return PAYMENT_METHOD_CARD;
	}

	updateFields(paymentMethodResult) {
		console.log("PaymentMethodUtils.updateFields", paymentMethodResult);

		if(paymentMethodResult) {
			const { paymentMethod, paymentIntent } = paymentMethodResult;

			const paymentMethodId = paymentMethod?.id ?? paymentIntent?.payment_method;
			
			this.ui.paymentMethodIdField.val(paymentMethodId);

			if(paymentIntent?.id) {
				this.ui.paymentIntentIdField.val(paymentIntent.id);
			}
		}

		// This field is used to determine what type of payment was made
		this.ui.paymentMethodField.val(this.getUsedPaymentMethod());
	}

	onClickCardBtn() {
		console.log("PaymentMethodUtils.onClickCardBtn");

		this.ui.cardPaymentText.show();
		this.ui.cardElementsContainer.show();

		this.ui.billingNameLabel.text('Name on card');
    }
}